// AgriLinkBookWorld.jsx  
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Tooltip from '../../components/utils/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faCheck, faClipboardCheck, faSpinner, faFileAlt } from '@fortawesome/free-solid-svg-icons';

const AgriLinkBWButtons = [
    {
      "id": "think5whys",
      "text": "Think5Whys",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'think5whys')"
    },
    {
      "id": "collections",
      "text": "Collections",
      "backgroundColor": "#ffff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'collections')"
    },
    {
      "id": "bluenext",
      "text": "BlueNext",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'BlueNext')"
    },
    {
      "id": "bluenextmonthly",
      "text": "BlueNextMonthly",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'BlueNextMonthly')"
    }
  ];


const AgriLinkBookWorldListComponent = ({ param1, param2 }) => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();

  const [bookMasters, setBookMasters] = useState([]);
  const [myBooks, setMyBooks] = useState([]);
  const [bookCollection, setBookCollection] = useState([]);

  const [highlightStates, setHighlightStates] = useState({});
  const [collectionStates, setCollectionStates] = useState({});
  const [subCollectionBooks, setSubCollectionBooks] = useState({});
  const [bookMasterRecords, setBookMasterRecords] = useState(0);

  const [searchGroup, setSearchGroup] = useState();
  const [searchText, setSearchText] = useState();

  useEffect(() => {
    setSearchGroup(param1);
    setSearchText(param2);
  }, [param1, param2]);

  const fetchBookMasters = useCallback(() => {
    const config = {
      url: "/bookmasters",
      method: "get",
      headers: { Authorization: authState.token, "Content-Type": "application/json" },
    };

    fetchData(config, { showSuccessToast: false })
      .then(response => {
        if (response && Array.isArray(response.bookmasters)) {
          setBookMasters(response.bookmasters);
          setBookMasterRecords(response.bookmasters.length);
        }
      })
      .catch(error => console.error("Error fetching BookMasters:", error));
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchBookMasters();
  }, [authState.isLoggedIn, fetchBookMasters]);

  const fetchMyBooks = useCallback(() => {
    const config = {
      url: "/mybooks",
      method: "get",
      headers: { Authorization: authState.token }
    };

    fetchData(config, { showSuccessToast: false })
      .then(response => {
        if (response && Array.isArray(response.mybooks)) {
          setMyBooks(response.mybooks);
        }
      })
      .catch(error => console.error("Error fetching MyBooks:", error));
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchMyBooks();
  }, [authState.isLoggedIn, fetchMyBooks]);

  const fetchCollectionBooks = useCallback(() => {
    const config = {
      url: "/bookcollections",
      method: "get",
      headers: { Authorization: authState.token }
    };

    fetchData(config, { showSuccessToast: false })
      .then(response => {
        if (response) setBookCollection(response);
      })
      .catch(error => console.error("Error fetching Book Collection:", error));
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchCollectionBooks();
  }, [authState.isLoggedIn, fetchCollectionBooks]);

  const toProperCase = (str) =>
    str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

  const filteredAndSortedBooks = (books, param2) => {
    let miniBookMasters = [];
    switch (param2.toLowerCase()) {
      case 'think5whys':
        miniBookMasters = books.filter(book => book.isT5W === 1 && !book.isCollection && book.isAvailable === 1);
        break;
      case 'collections':
        miniBookMasters = books.filter(book => book.tabGroup === 'BlueNext' && book.isCollection && book.isAvailable === 1);
        break;
      case 'bluenext':
        miniBookMasters = books.filter(book => book.tabGroup === 'BlueNext' && !book.isCollection && book.isAvailable === 1);
        break;
      case 'bluenextmonthly':
        miniBookMasters = books.filter(book => book.tabGroup === 'BlueNextMonthly' && !book.isCollection && book.isAvailable === 1);
        break;
      default:
        miniBookMasters = books.filter(book => book.tabGroup === 'BlueNext' && !book.isCollection && book.isAvailable === 1);
        break;
    }
    return miniBookMasters.sort((a, b) => a.displayIndex - b.displayIndex);
  };

  const scrollToDetail = (bookCode) => {
    const detailElement = document.getElementById(`book-detail-${bookCode}`);
    if (detailElement) {
      detailElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleBookDetailsClick = (bookId, bookTitle, book, hasPurchased, isFree, isCollection) => {
    navigate('/buying-bookdetails', {
      state: { bookId, bookData: book, hasPurchased, isCollection }
    });
  };

  return (
    <div className="flex flex-col items-center w-full px-3">
        {loading ? (
        <div className="flex justify-center items-center py-10 text-white text-lg">
            <FontAwesomeIcon icon={faSpinner} spin /> <span className="ml-2">AgriLink</span>
        </div>
        ) : (
        <>
            <div className='w-full border border-green-400 p-4 px-4'>
                <div className="w-full flex flex-col items-center text-white">
                    <p className="text-lg lg:text-2xl py-2 px-4 text-center font-semibold">{param2.toUpperCase()} Books World </p>

                    {bookMasterRecords < 1 && (
                        <p className="text-yellow-500 text-lg lg:text-xl mt-2 text-center">
                        No Books Available in {param2.toUpperCase()} Books World
                        </p>
                    )}
                </div>

                <div className="mt-4 flex flex-wrap justify-center gap-3">
                    {filteredAndSortedBooks(bookMasters, param2).map(book => (
                        <div
                            key={book.bookCode}
                            onClick={() => scrollToDetail(book.bookCode)}
                            className="flex flex-col items-center cursor-pointer w-24"
                        >
                            <img
                                src={`/api/bookworldthumb/${book.bookImage}.png`}
                                alt={book.bookTitle}
                                className="w-24 h-auto"
                            />
                        </div>
                    ))}
                </div>

                <p className="text-white text-center mt-4 text-sm"> We have {filteredAndSortedBooks(bookMasters, param2).length} Items in {toProperCase(param2)}!</p>
            </div>
            {filteredAndSortedBooks(bookMasters, param2).map(book => (
                <div
                    key={book.bookCode}
                    id={`book-detail-${book.bookCode}`}
                    className="w-full bg-gray-900/40 rounded-lg p-4 mt-5 border border-teal-400"
                >

                    <div className="flex justify-center mb-3">
                        <img
                            src={`/api/bookworldthumb/${book.bookImage}.png`}
                            alt={book.bookTitle}
                            className="w-24 h-auto"
                        />
                    </div>

                    <h2 className="text-lg text-white text-center font-semibold"> {book.bookTitle}</h2>

                <div className="flex justify-center mt-3 mb-3 gap-4 text-green-500">
                    <Tooltip text={book.hasPracticeTest ? "Has Practice Test" : "No Practice Test"}>
                        <FontAwesomeIcon icon={faCheck} className="text-2xl" />
                    </Tooltip>

                    <Tooltip text={book.hasAssignment ? "Has Assignment" : "No Assignment"}>
                        <FontAwesomeIcon icon={faFileAlt} className="text-2xl" />
                    </Tooltip>

                    <Tooltip text={book.hasExam ? "Has Exam" : "No Exam"}>
                        <FontAwesomeIcon icon={faClipboardCheck} className="text-2xl" />
                    </Tooltip>

                    <Tooltip text={book.hasCertificate ? "Has Certificate" : "No Certificate"}>
                        <FontAwesomeIcon icon={faCertificate} className="text-2xl" />
                    </Tooltip>
                </div>

                {myBooks.find(myBook => myBook.bookId === book._id) ? (
                <div className="text-center">
                    <p className="inline-block text-teal-800 bg-yellow-400 text-lg font-semibold px-2 py-1 rounded">Already in Your BookShelf</p>
                    <p className="text-purple-400 mt-1">You may Gift it</p>

                    <button
                        onClick={() => handleBookDetailsClick(book._id, book.bookTitle, book, true)}
                        className="mt-3 text-sm bg-teal-600 text-white px-4 py-2 rounded-lg w-36"
                    >
                        Explore
                    </button>
                </div>
                ) : (
                <div className="text-center">
                    <button
                        onClick={() => handleBookDetailsClick(book._id, book.bookTitle, book, false)}
                        className="mt-3 text-sm bg-purple-600 text-white px-4 py-2 rounded-lg w-36"
                    >
                      Details
                    </button>
                </div>
                )}

                <p className={`text-center mt-3 text-xl font-semibold ${
                    book.isAvailable ? 'text-green-500' : 'text-yellow-500'
                    }`}>
                    {book.isAvailable ? "Available in Store" : "Currently Unavailable"}
                </p>

                {book.isCollection && (
                <>
                    <div className="text-center mt-3">
                        <button
                            onClick={() => {
                            setCollectionStates(prev => ({ ...prev, [book._id]: !prev[book._id] }));
                            if (!collectionStates[book._id]) {
                                setSubCollectionBooks(prev => ({
                                ...prev,
                                [book._id]: bookCollection.filter(c => c.collectionId === book._id)
                                }));
                            }
                            }}
                            className="text-sm bg-yellow-600 text-black px-4 py-2 rounded-lg"
                        >
                            {collectionStates[book._id] ? "Hide Book List" : "Show Book List"}
                        </button>
                    </div>

                    {collectionStates[book._id] && (
                        <div className="mt-3 text-white">
                            <p className="text-purple-500 text-center font-semibold">Books in this Collection</p>
                            {subCollectionBooks[book._id]?.map((cb, i) => (
                            <div key={i} className="bg-teal-700 px-3 py-2 mt-1 rounded">
                                <p>{i + 1}. {cb.bookTitle}</p>
                            </div>
                            ))}
                        </div>
                    )}
                </>
                )}

                {book.bookHighlight && (
                <>
                    <div className="text-center mt-3">
                        <button
                            onClick={() =>
                            setHighlightStates(prev => ({ ...prev, [book._id]: !prev[book._id] }))
                            }
                            className="inline-flex items-center justify-center text-sm bg-green-600 text-white px-4 py-2 rounded-lg w-40"
                        >
                            {highlightStates[book._id] ? "Hide Highlights" : "Show Highlights"}
                        </button>
                    </div>

                    {highlightStates[book._id] && (
                        <div
                            className="flex flex-col justify-center items-center mt-3 text-white bg-black p-3 rounded"
                            dangerouslySetInnerHTML={{ __html: book.bookHighlight }}
                        />
                    )}
                </>
                )}
            </div>
            ))}
        </>
        )}
    </div>
    );

};

const AgriLinkBookWorld = () => {
  const navigate = useNavigate();
  const [param1, setParam1] = useState("f");
  const [param2, setParam2] = useState("sakshamshakti");
  const [hoveredButton, setHoveredButton] = useState(null);
  const [activeButton, setActiveButton] = useState(null);

  const handleHover = (id) => setHoveredButton(id);
  const handleBlur = () => setHoveredButton(null);

  const setSearch = (p1, p2) => {
    setParam1(p1);
    setParam2(p2);
  };

  const handleClick = (action, id) => {
    if (action.startsWith("setSearch")) {
      const params = action.match(/\(([^)]+)\)/)[1].split(",")
        .map(param => param.trim().replace(/['"]/g, ""));
      setSearch(params[0], params[1]);
    }
    setActiveButton(id);
  };

  return (
    <div className="min-h-screen bg-black py-8 px-3">
        <h2 className="text-center text-yellow-200 font-bold text-xl">Farmer & Rural Monthly Magazine and Farmer & Rural Awareness and Literacy Book World</h2>
        <p className="text-center text-white mt-1 mb-4 text-sm">Select The Desired Button To Explore Available Books</p>

        <div className="w-full">
            <div className="w-full flex flex-wrap justify-center items-center gap-3">
                {AgriLinkBWButtons.map(button => (
                <button
                    key={button.id}
                    id={button.id}
                    onClick={() => handleClick(button.onClick, button.id)}
                    onMouseEnter={() => handleHover(button.id)}
                    onMouseLeave={handleBlur}
                    className={`
                    w-40 lg:w-48 px-2 py-2 rounded-lg text-center
                    font-semibold text-xs lg:text-sm transition-all duration-200
                    `}
                    style={{
                    backgroundColor:
                        hoveredButton === button.id
                        ? button.hoverBackgroundColor
                        : button.backgroundColor,
                    color:
                        hoveredButton === button.id
                        ? button.hoverColor
                        : button.color
                    }}
                >
                    {button.text}
                </button>
                ))}
            </div>

            <div className="mt-2 w-full flex justify-center">
                {activeButton && (
                <AgriLinkBookWorldListComponent
                    param1={param1}
                    param2={param2}
                />
                )}
            </div>

            </div>

    </div>
    );
};

export default AgriLinkBookWorld;
